import * as angular from 'angular';

import { ComponentDefinition, RowDefinition, TicketViewModel } from '../../../../models';
import { HeadingDefinition } from '../../../../widgets/logbookTable/HeadingDefinition';
import { getHeadings, getBody } from '../buildTable';


class AuditReportTableController implements angular.IComponentController {
    body: RowDefinition[][];
    completionDates: { [ticketId: number]: number };
    headings: HeadingDefinition[];
    
    readonly tickets: TicketViewModel[];

    static $inject = [];

    $onInit() {
        this.headings = getHeadings();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (this.tickets) {
            this.body = getBody(this.tickets);
        }
    }
}

export const wtAuditReportTable: ComponentDefinition = {
    componentId: 'wtAuditReportTable',
    controller: AuditReportTableController,
    template: require('./auditReportTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        tickets: '<'
    }
};
